import React, {useEffect, useRef, useState} from 'react';
import APPCONFIG from '../../../../constants/Config';

const resolveImageUrl = (url) => {
	if (!url) {
		return '';
	}
	if (/^https?:\/\//i.test(url)) {
		return url;
	}
	const path = url.startsWith('/') ? url : `/${url}`;
	return `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}${path}`;
};

const AdsModule = ({config}) => {
	const slides = Array.isArray(config && config.slides) ? config.slides : [];
	const intervalMs = (config && config.intervalMs) || 5000;
	const [index, setIndex] = useState(0);
	const slidesRef = useRef(slides);
	slidesRef.current = slides;

	// Keep index in range when the slide list changes (e.g. an ad was removed).
	useEffect(() => {
		if (!slides.length) {
			setIndex(0);
			return;
		}
		setIndex((current) => current % slides.length);
	}, [slides.length]);

	useEffect(() => {
		if (slides.length <= 1) {
			return undefined;
		}
		const timer = setInterval(() => {
			const count = slidesRef.current.length;
			if (count <= 1) {
				return;
			}
			setIndex((current) => (current + 1) % count);
		}, intervalMs);
		return () => clearInterval(timer);
	}, [slides.length, intervalMs]);

	// Preload images so slide changes are not blank.
	useEffect(() => {
		slides.forEach((slide) => {
			if (!slide || !slide.imageUrl) {
				return;
			}
			const img = new Image();
			img.src = resolveImageUrl(slide.imageUrl);
		});
	}, [slides]);

	if (!slides.length) {
		return <div>No ad slides configured.</div>;
	}

	const safeIndex = index % slides.length;
	const active = slides[safeIndex] || {};

	return (
		<div style={{padding: '16px', border: '1px solid #dcdcdc', borderRadius: '6px'}}>
			{active.imageUrl ?
				<img
					key={resolveImageUrl(active.imageUrl)}
					src={resolveImageUrl(active.imageUrl)}
					alt={active.title || 'Advertisement'}
					style={{width: '100%', maxHeight: '220px', objectFit: 'contain'}}
				/>
				:
				<>
					<h5 style={{marginTop: 0}}>{active.title || 'Advertisement'}</h5>
					<p style={{marginBottom: 0}}>{active.body || ''}</p>
				</>
			}
			{slides.length > 1 ?
				<div style={{textAlign: 'center', marginTop: '8px', color: '#777', fontSize: '0.85rem'}}>
					{safeIndex + 1} / {slides.length}
				</div>
				: null}
		</div>
	);
};

export default AdsModule;
